import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "Associationsstyle__Container"
})(["position:relative;"]);